import { render, staticRenderFns } from "./definition-love-brand.vue?vue&type=template&id=e5cc4eb6&"
import script from "./definition-love-brand.vue?vue&type=script&lang=js&"
export * from "./definition-love-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports